import type { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isEmptyInputValue } from './shared';
const PLACEHOLDER = '$value';

export class ValueExpressionValidator {
  public static mathExpression(control: AbstractControl): ValidationErrors | null {
    return ValueExpressionValidator.validate(control, ['$value']);
  }

  public static mathExpressionWithDollarObject(control: AbstractControl): ValidationErrors | null {
    return ValueExpressionValidator.validate(control, ['$object']);
  }

  public static mathExpressionWithVariables(variableNames: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (isEmptyInputValue(control.value)) {
        return null; // don't validate empty values to allow optional controls
      }

      return ValueExpressionValidator.validate(control, variableNames);
    };
  }

  private static validate(control: AbstractControl, _valueNames: string[] = [PLACEHOLDER]): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null; // don't validate empty values to allow optional controls
    }

    return null;
  }
}
